
import { Permission } from "./types";

// Key for localStorage
export const PERMISSIONS_STORAGE_KEY = 'rolePermissions';

// Default permissions configuration
export const defaultPermissions: Permission[] = [
  // Medewerker rol - very limited access by default
  { id: "1", role: "medewerker", resource: "dashboard", read: true, write: false, delete: false },
  { id: "2", role: "medewerker", resource: "orders", read: false, write: false, delete: false },
  { id: "3", role: "medewerker", resource: "inventory", read: false, write: false, delete: false },
  { id: "4", role: "medewerker", resource: "colorCheck", read: false, write: false, delete: false },
  { id: "5", role: "medewerker", resource: "notifications", read: true, write: false, delete: false },
  { id: "6", role: "medewerker", resource: "reports", read: false, write: false, delete: false },
  { id: "7", role: "medewerker", resource: "medewerkers", read: false, write: false, delete: false },
  { id: "22", role: "medewerker", resource: "feedback", read: true, write: true, delete: false },
  
  // Planner rol
  { id: "8", role: "planner", resource: "dashboard", read: true, write: true, delete: false },
  { id: "9", role: "planner", resource: "orders", read: true, write: true, delete: true },
  { id: "10", role: "planner", resource: "inventory", read: true, write: true, delete: true },
  { id: "11", role: "planner", resource: "colorCheck", read: true, write: true, delete: true },
  { id: "12", role: "planner", resource: "notifications", read: true, write: true, delete: true },
  { id: "13", role: "planner", resource: "reports", read: true, write: true, delete: false },
  { id: "14", role: "planner", resource: "medewerkers", read: false, write: false, delete: false },
  { id: "23", role: "planner", resource: "feedback", read: true, write: true, delete: false },
  
  // Management rol - full access to everything
  { id: "15", role: "management", resource: "dashboard", read: true, write: true, delete: true },
  { id: "16", role: "management", resource: "orders", read: true, write: true, delete: true },
  { id: "17", role: "management", resource: "inventory", read: true, write: true, delete: true },
  { id: "18", role: "management", resource: "colorCheck", read: true, write: true, delete: true },
  { id: "19", role: "management", resource: "notifications", read: true, write: true, delete: true },
  { id: "20", role: "management", resource: "reports", read: true, write: true, delete: true },
  { id: "21", role: "management", resource: "medewerkers", read: true, write: true, delete: true },
  { id: "24", role: "management", resource: "feedback", read: true, write: true, delete: true },
  
  // Package Pickup permissions
  { id: "25", role: "medewerker", resource: "packagePickup", read: true, write: false, delete: false },
  { id: "26", role: "planner", resource: "packagePickup", read: true, write: true, delete: false },
  { id: "27", role: "management", resource: "packagePickup", read: true, write: true, delete: true },
];
